export default path => '/tires/trailer'.includes(path)
